export interface Message {
  messageId?: string;
  type: MessageType;
  buttons: MessageButtons;
  title: string;
  msg?: string;
  errorHash?: string;
  closeable?: boolean;
  onCancel?: (...args: any[]) => any;
  onSave?: (...args: any[]) => any;
  onNo?: (...args: any[]) => any;
  onYes?: (...args: any[]) => any;
  customButtons?: MessageButton[];
  width?: any;
}

export enum MessageType {
  INFO = 'INFO',
  WARNING = 'WARNING',
  ERROR = 'ERROR',
}

export enum MessageButtons {
  CLOSE = 'CLOSE',
  YES_NO = 'YES_NO',
  SAVE_CANCEL = 'SAVE_CANCEL',
  CONTACT = 'CONTACT',
  CUSTOM = 'CUSTOM',
}

export interface MessageButton {
  label: string;
  onClick: (...args: any[]) => any;
  isAccent: boolean;
}
